module.exports = __webpack_public_path__ + "img/دولت.53997ec3.png";